export default __webpack_public_path__ + "static/media/recorte_20.380eb8f3.JPG";